// Re-export these from @corca/data because of the types.
// Types depend on the code from the app so we can't move it to the package.
// We can move GroupsJson and DecoratorsJson types to the @corca/data package when we
// move DocumentModel and nodes models to the separate package.

import _decoratorsJson from "@corca/data/decorators.json";
import _groupsJson from "@corca/data/groups.json";

import type { GroupsJson, DecoratorsJson } from "./types";

export const groupsJson = _groupsJson as GroupsJson;
export const decoratorsJson = _decoratorsJson as DecoratorsJson;
